<template>
  <div>
    <div :class="mapClassName" id="map" ref="map"></div>
  </div>
</template>

<script>
import { isGoogleMapLoaded, load } from "../helpers/landingUtils";
import { googleApiEndpoints } from "../config/apiEndpoints";
export default {
  name: "MapComponent",
  props: {
    mapClassName: {
      type: String,
      default: "map-container",
    },
    initializeMapFeatures: {
      type: Function,
      default: (map, mapRef) => {},
    },
    mapCenter: {
      type: Object,
      default: { lat: 28.531641, lng: 77.362122 },
    },
    disableGestureHandling: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      directionsList: {},
      map: {},
    };
  },
  mounted() {
    this.initializeMap();
  },
  methods: {
    initializeMap(count = 0) {
      if (isGoogleMapLoaded() && window.google) {
        this.map = new window.google.maps.Map(this.$refs["map"], {
          center: this.mapCenter,
          disableDefaultUI: true,
          gestureHandling: this.disableGestureHandling ? "none" : "greedy",
          mapTypeId: google.maps.MapTypeId.ROADMAP,
        });
        this.initializeMapFeatures(this.map, this.$refs["map"]);
      } else if (count < 3) {
        load(googleApiEndpoints.MAP_URL)
          .then(() => {
            this.initializeMap(++count);
          })
          .catch(() => {
            this.initializeMap(++count);
          });
      }
    },
    // focusStoreSlideByLocation(index) {
    //   let currentLocation = this.$store.state.Location.currentLocation;
    //   this.$store.commit(keyMapsMutation.UPDATE_FOCUSED_STORE, index);
    //   MapUtils.showDrivingDirection({
    //     origin: currentLocation,
    //     destination: {
    //       lat: this.takeawayStoreList[index].store.stations[0].latitude,
    //       lng: this.takeawayStoreList[index].store.stations[0].longitude,
    //     },
    //     map: this.map,
    //   });
    // },
  },
  computed: {
    takeawayStoreList() {
      return this.$store.state.Location.takeawayStoreList;
    },
  },
  watch: {
    takeawayStoreList: {
      handler(newVal, oldVal) {
        if (newVal.length > 0 && newVal !== oldVal) {
          this.initializeMap()
        }
      },
    },
  },
};
</script>
